import { prefixPluginTranslations } from '@strapi/helper-plugin';
import pluginPkg from '../../package.json';
import pluginId from './pluginId';
import Initializer from './components/Initializer';
import PluginIcon from './components/PluginIcon';
import RegulatoryExam from './containers/RegulatoryExam';
import { DuplicateButton } from './components/DuplicateButton';
import WidenButton from './components/WidenButton';
import ContainerTypeField from './components/ContainerTypeField';
const name = pluginPkg.strapi.name;
export default {
  register(app) {
    app.addFields([{
      type: 'regulatory_exam',
      Component: RegulatoryExam
    }, {
      type: 'duplicate_button',
      Component: DuplicateButton
    }, {
      type: 'widen-media',
      Component: WidenButton
    }, {
      type: 'container-type',
      Component: ContainerTypeField
    }]);
  },
  bootstrap(app) {},
  async registerTrads({
    locales
  }) {
    const importedTrads = await Promise.all(locales.map(locale => {
      return import(`./translations/${locale}.json`).then(({
        default: data
      }) => {
        return {
          data: prefixPluginTranslations(data, pluginId),
          locale
        };
      }).catch(() => {
        return {
          data: {},
          locale
        };
      });
    }));
    return Promise.resolve(importedTrads);
  }
};